import React,{useState,useEffect} from "react";
import { refreshNotifications } from "../utils/notifications";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Grid,
} from "@mui/material";
import { withRouter } from "../utils/router";
import EnhancedTable from "./enhancedTable";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import { formatWhen } from "../utils/format";
import ListParty from "./listParty";
import {
  updateRecordingStatus,
  updateRecordings,
  forwardRecording,
  deleteRecording,
} from "../utils/utils";
import {
  setNotifications,
  setNotificationsLoading,
} from "../store/features/notification/notificationSlice";
import { setCalls } from "../store/features/calls/callSlice";
import { setVoicemails } from "../store/features/voicemails/voicemailSlice";
import { setSmsConversations } from "../store/features/smsConversations/smsConversationsSlice";
import { setFaxes } from "../store/features/faxes/faxSlice";
import { setRecordings } from "../store/features/recordings/recordingSlice";
import { setError } from "../store/features/error/errorSlice";
import Forward from "./forward";
import EditTitle from "./editTitle";
import { resetSession } from "../store/features/session/sessionSlice";

const mapDispatchToProps = {
  setError,
  setCalls,
  setVoicemails,
  setSmsConversations,
  setFaxes,
  setRecordings,
  setNotifications,
  setNotificationsLoading,
  resetSession,
};

const headCells = {
  all: [
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Recording",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    { id: "received", numeric: true, disablePadding: false, label: "Recorded" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ],
  new: [
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Recording",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    { id: "received", numeric: true, disablePadding: false, label: "Recorded" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ],
  viewed: [
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Recording",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    { id: "received", numeric: true, disablePadding: false, label: "Recorded" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ],
  urgent: [
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Recording",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    { id: "received", numeric: true, disablePadding: false, label: "Recorded" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ],
  deleted: [
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Recording",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    { id: "received", numeric: true, disablePadding: false, label: "Recorded" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ],
};


const Recording = (props) => {
  const {
    title,
    menu,
    menuItems,
    history,
    recordings,
    session,
    resetSession,
    setVoicemails,
    setSmsConversations,
    setFaxes,
    setRecordings,
    setNotifications,
    setNotificationsLoading,
    handleDialClick,
    notifications,
    setValue,
    match,
    setError,
  } = props;

  let recordingTab = match.params.recordingTab;
  const [page,setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [forward, setForward] = useState(false);
  const [forwardItem, setForwardItem] = useState(null)
  const [titleChangeItem, setTitleChangeItem] = useState(null);
  const [titleModal, setTitleModal] = useState(false)
  const defaultValues = {
    server: session.lastServer,
    token: session.token,
  };

  // The "what" cell of a row: an icon, the title, and a dot on new ones.
  const renderTitle = (item) => {
    const isNew = String(item.type || "").toLowerCase() === "new";
    const title = String(item.title || "").replace(/\.(wav|mp3|gsm|ogg|m4a)$/i, "").trim() || "Recording";
    return (
      <ListParty
        icon={<GraphicEqIcon />}
        tone={isNew ? "brand" : "neutral"}
        title={title}
        isNew={isNew}
        wrap
      />
    );
  };

  const createRow = (item, deleted) => ({
    title: renderTitle(item),
    status: item.type,
    received: formatWhen(item.dateTime),
    actions: deleted
      ? [{ type: "delete" }]
      : [
          { type: "delete" },
          { type: "download" },
          { type: "editTitle" },
          { type: "play" },
          { type: "forward" },
        ],
    object: item,
  });

  // Which recordings each tab shows; the data calls a viewed recording "old".
  const tabFilters = {
    all: (type) => type !== "deleted",
    new: (type) => type === "new",
    viewed: (type) => type === "old",
    urgent: (type) => type === "urgent",
    deleted: (type) => type === "deleted",
  };

  const generateRows = ()=>{
    const matches = tabFilters[recordingTab];
    if (!matches) return undefined;
    // Search: the title of the recording, as the list shows it.
    const term = searchTerm.trim().toLowerCase();
    return recordings
      .filter((item) => matches(String(item.type || "").toLowerCase()))
      .filter((item) => term.length < 2 || (String(item.title || "").trim() || "Recording").toLowerCase().includes(term))
      .map((item) => createRow(item, recordingTab === "deleted"));
  }

  const refetchNotifications = () => refreshNotifications({
    values: defaultValues,
    setters: { setCalls, setFaxes, setRecordings, setVoicemails, setSmsConversations },
    setNotifications,
    setNotificationsLoading,
    onUnauthorized: () => {
      resetSession();
      history.push('/login');
    },
  });

  const clearCurrentNotifications = () =>{
    let values = defaultValues;

    values.recordings = recordings
      .filter(
        (recording) =>
          recording.viewed !== "yes"
      )
      .map((recording) => {
        return {
          rid: recording.rid,
          viewed: "yes",
          title: recording.title,
          type: recording.type
        };
      });

    try {
      updateRecordings(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    clearCurrentNotifications();
    // eslint-disable-next-line
  }, [recordingTab, title]);

  const handleStatusChange = async (type,item) => {
    let recordingType =
      type.toLowerCase() === "viewed" ? "old" : type.toLowerCase();
    try {
      await updateRecordingStatus(defaultValues, item.rid, recordingType);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDelete = (items) => {
    let values = defaultValues;

    values.recordings = items.map((item) =>
      item.hasOwnProperty("object")
        ? {
            rid: item.object.rid,
            title: item.object.title,
            viewed: "yes",
            type: "deleted",
          }
        : {
            rid: item.rid,
            title: item.title,
            viewed: "yes",
            type: "deleted",
          }
    );

    try {
      updateRecordings(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDeleteForever = (item) => {
    let values = defaultValues;
    values.id = item.rid

    try {
      deleteRecording(values);
      setError({
        visible: true,
        type: "success",
        message: "Successfully deleted Item",
      });
      refetchNotifications();
    } catch (error) {
      setError({
        visible: true,
        type: "error",
        message: error,
      });
      console.error(error);
    }
  }

  return (
    <Grid container>
      <Grid size={12}>
        <Forward
          open={forward}
          setOpen={setForward}
          value={forwardItem}
          type="Recording"
          forwardFunction={forwardRecording}
          idKey="rid"
          defaultValues={defaultValues}
        />
        {titleModal && (
          <EditTitle
            open={titleModal}
            setOpen={setTitleModal}
            value={titleChangeItem}
            type="Recording"
            defaultValues={defaultValues}
            setTitleChangeItem={setTitleChangeItem}
            reloadNotifications={refetchNotifications}
          />
        )}

        <EnhancedTable
          setError={setError}
          type="recording"
          headerData={headCells}
          rowData={generateRows()}
          dense={false}
          hasActions={true}
          selectable={true}
          menu={menu ? menuItems : false}
          searchFunc={(value) => { setSearchTerm(value); setPage(0); }}
          emptyText={searchTerm.trim().length >= 2 ? "No recordings match your search." : undefined}
          title={title}
          tab={recordingTab}
          history={history}
          hasClear={false}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          handleDialClick={handleDialClick}
          setValue={setValue}
          setForwardItem={setForwardItem}
          setForward={setForward}
          loading={notifications.loading}
          statusChangeFunction={handleStatusChange}
          handleDelete={handleDelete}
          handleDeleteForever={handleDeleteForever}
          setTitleChangeItem={setTitleChangeItem}
          setEditTitle={setTitleModal}
          useGroupFilter={false}
          refreshDataOnSameTab={clearCurrentNotifications}
        />
      </Grid>
    </Grid>
  );
};

Recording.propTypes = {
  title: PropTypes.string.isRequired,
  menu: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkId: PropTypes.string,
    })
  ),
  tab: PropTypes.string.isRequired,
  handleDialClick: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    recordings: state.recordings,
    notifications: state.notifications,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Recording)
);